import type { FaireProductEntity } from "../../entity_types/product";

export const p_v8b2gufyh6: FaireProductEntity = {
  token: "p_v8b2gufyh6",
  type: "product",
  name: "Merci Beau Coup",
  brandToken: "b_b9ze9cg9",
  brandName: "Etc. Letterpress",
  imageUrl:
    "https://cdn.faire.com/fastly/6a3b3d1ca029f5d043f710377f293c6763300d16b842233e9770b4169f788312.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0ff030fcb25a699f26a0827a038936d93ac40df27a620bedfd6a271b61cffec.jpeg",
  ],
  priceDollars: 3,
  description:
    "A card when you want to send a lot of thanks!\n\nLetterpress printed on 100% cotton rag paper. Comes packaged with a kraft envelope in a compostable cello sleeve as in the included image. 4-bar size.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:14.038Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
